import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { DxFormComponent, DxPopupComponent, DxValidatorComponent } from 'devextreme-angular';
import { ConstantsService } from 'src/app/services/constants.service';
import { CashUpInfo } from 'src/app/services/terminal.service';

@Component({
  selector: 'app-close-till-discrepancy',
  templateUrl: './close-till-discrepancy.component.html',
  styleUrls: ['./close-till-discrepancy.component.css']
})
export class CloseTillDiscrepancyComponent implements OnInit {

  @Output() CloseDlg: EventEmitter<CashUpInfo> = new EventEmitter<CashUpInfo>();
  @ViewChild(DxPopupComponent) popup: DxPopupComponent;
  @ViewChild(DxFormComponent) form: DxFormComponent;
  @ViewChild("vgReason") vgReason: DxValidatorComponent;

  cashUpInfo: CashUpInfo = new CashUpInfo();

  OKButtonOptions = {
    text: 'OK',
    onClick: this.btnOk.bind(this)
  };

  constructor(public constants: ConstantsService) {
    this.onShown = this.onShown.bind(this);
  }

  ngOnInit(): void {
  }

  onInit(e: any) {
    e.component.registerKeyHandler("escape", function (arg) {
      arg.stopPropagation();
    });
  }

  onShown(e) {
    if (this.vgReason) {
      this.vgReason.instance.reset();
    }
  }

  public show(cashUpInfo: CashUpInfo) {
    this.cashUpInfo = cashUpInfo;
    this.cashUpInfo.DiscrepancyReason = null;
    this.popup.visible = true;
  }

  btnOk(e) {
    const v = this.form.instance.validate();
    if (v.isValid === false) {
      return;
    }
    this.popup.visible = false;
    this.CloseDlg.emit(this.cashUpInfo);
  }
}
